module.exports = __webpack_public_path__ + "static/img/smaco-12.95398f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/smaco-12.jpg
// module id = 2ZF+
// module chunks = 1